import debug from 'debug'

const d = debug('mappy:utils')

export type DeepLinkingConfig = {
  timeoutMs?: number
  onNavigateToApp: () => void
  onNavigateToStore: () => void
}

export const attemptDeepLinking = (config: DeepLinkingConfig): void => {
  const { timeoutMs = 3_000, onNavigateToApp, onNavigateToStore } = config

  const clickTimestamp = Date.now()

  onNavigateToApp()

  setTimeout(() => {
    const elapsedTime = Date.now() - clickTimestamp

    // Only trigger fallback if:
    // 1. Page is still visible (user didn't navigate away)
    const isVisible = document.visibilityState === 'visible'
    // 2. timeout is called when expected (not after the user has used the app)
    const hasLongTimePassed = elapsedTime < timeoutMs + 500

    const shouldFallbackToStore = isVisible && hasLongTimePassed

    if (d.enabled)
      d('shouldFallbackToStore', shouldFallbackToStore, 'isVisible', isVisible, 'hasLongTimePassed', hasLongTimePassed)

    if (shouldFallbackToStore) onNavigateToStore()
  }, timeoutMs)
}
